import { logger } from '../../../../../utils/common/logger'
import { IAd } from '../../../ad'
import { IAdBidder } from './base'

class ParallelBiddingManager {
    public bidders: IAdBidder[]

    constructor() {
        this.bidders = []
    }

    public registerBidder(bidder: IAdBidder): void {
        if (bidder.shouldWaitForBidder()) {
            logger('debug', 'Registering parallel bidder', bidder)
            if (this.bidders.indexOf(bidder) === -1) {
                this.bidders.push(bidder)
            }
        }
    }

    public async sendBidderRequests(ads?: IAd[], slot?: any) {
        await Promise.all(
            this.bidders.map(async (bidder) => {
                return bidder.requestAdsPromise(ads, slot)
            })
        )

        logger('info', `Parallel bidder promises are finished and ready to request ads: `, ads)
        document.dispatchEvent(new Event('all-bidding-complete'))
    }
}

export default ParallelBiddingManager
